import React, { useEffect, useState, useRef } from "react";

import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import greenTick from "../../assets/images/greenTick.png";

const SavedSuccessModal = ({
  savedSuccessModalOpen,
  closeModal,
  handleSubmit,
  handleSelectFiles,
  files,
  disabledUpload,
}) => {
  return (
    <>
      <Dialog
        open={savedSuccessModalOpen}
        onClose={closeModal}
        sx={{ "& .MuiDialog-paper": { minWidth: "350px" } }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignpolicyDetailss: "center",
          }}
        >
          {/* <CloseIcon
            onClick={() => closeModal()}
            color="primary"
            sx={{
              height: "100%",
              cursor: "pointer",
            }}
          /> */}
        </DialogTitle>
        <DialogContent sx={{ py: 2, px: 8 }}>
          <Grid
            container
            size={{ xs: 12, md: 6 }}
            justifyContent="center"
            alignItems="center"
            spacing={2} // Add spacing between items
            sx={{
              m: 1,
            }}
          >
            <Grid
              item
              xs={12}
              sx={{ textAlign: "center" }} // Center the content within the item
            >
              <img
                src={greenTick}
                style={{ height: "auto", width: "auto%" }}
                alt="logo_image"
              />
              <Typography
                sx={{
                  color: "#182035",
                  textAlign: "center",
                  fontSize: "20px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  lineHeight: "normal",
                  mt: 2, // Add margin-top for spacing
                }}
              >
                Saved Successfully..!!
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  // color: "#182035",
                  textAlign: "center",
                  // fontSize: "20px",
                  // fontStyle: "normal",
                  // fontWeight: "700",
                  // lineHeight: "normal",
                  mt: 2, // Add margin-top for spacing
                }}
              >
                Award has been added and sent for approval.
              </Typography>

              <Button
                autoFocus
                variant="text"
                sx={{
                  mt: 4,
                  borderRadius: "8px",
                  pb: 2,
                  color: "var(--Gradient-Orange, #F5841F)",
                  background:
                    "var(--Gradient-Orange, linear-gradient(180deg, #F5841F 0%, #F36222 100%))",
                  backgroundClip: "text",
                  // -webkit-background-clip: text,
                  // -webkit-text-fill-color: transparent,
                }}
                onClick={handleSubmit}
              >
                Back To Home
              </Button>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          {/* <Button
            autoFocus
            variant="text"
            sx={{
              borderRadius: "8px",
              color: "var(--Gradient-Orange, #F5841F)",
              background:
                "var(--Gradient-Orange, linear-gradient(180deg, #F5841F 0%, #F36222 100%))",
              backgroundClip: "text",
              // -webkit-background-clip: text,
              // -webkit-text-fill-color: transparent,
            }}
            onClick={() => handleSubmit}
          >
            Back To Home
          </Button> */}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SavedSuccessModal;
